export const BASE_URL = "https://mymovielist-api-dhqp.onrender.com";
